import React, { Component } from 'react'
import { get, map } from 'lodash'
import { connect } from 'react-redux'
import firebase from 'firebase/app'
import { Segment, Form, Button, Header } from 'semantic-ui-react'

import AppCustomizationActions from '../../../../reducers/appCustomizationReducer'
import MenuActions from '../../../../reducers/menuReducer'

class PromotionCategory extends Component {
  constructor(props) {
    super(props)

    this.state = {
      saving: false,
      hasChanged: false,
      categoryKey: null,
    }
  }

  componentDidMount() {
    const { getCustomization, getMenus, promotionCategoryLoaded } = this.props

    if (!promotionCategoryLoaded) {
      getCustomization({
        screen: 'promotion',
        resource: 'category',
      })
    }

    getMenus()
  }

  componentDidUpdate(prevProps) {
    const { promoCategory } = this.props

    if (prevProps.promoCategory !== promoCategory) {
      const categoryKey = get(Object.values(promoCategory), '[0].key', null)

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ categoryKey })
    }
  }

  onSave = async () => {
    try {
      const { categoryKey } = this.state
      const { setSingleCustomization, promoCategory } = this.props

      this.setState({ saving: true })

      const ref = firebase
        .firestore()
        .collection('app_customization')
        .doc('promotion')
        .collection('category')

      const data = Object.values(promoCategory)

      const id = get(data, '[0].id', ref.doc().id)
      const createdAt = get(data, '[0].created_at', Date.now())

      const updates = {
        key: categoryKey,
        created_at: createdAt,
        updated_at: Date.now()
      }

      setSingleCustomization({
        screen: 'promotion',
        resource: 'category',
        data: { ...updates, id }
      })

      await ref.doc(id).set(updates)
    } catch (error) {
      alert('Failed to update promotion category')
    } finally {
      this.setState({ saving: false, hasChanged: false })
    }
  }

  render() {
    const { saving, categoryKey, hasChanged } = this.state
    const { loading, categories } = this.props

    return (
      <Segment color="black" loading={loading} style={{ height: 300 }}>
        <Header content="Category for Promotion" size="large" style={{ display: 'inline-block' }} />

        <div style={{ display: 'flex', marginTop: 15 }}>
          <Form.Select
            required
            search
            options={map(categories, (c, key) => ({ key, value: key, text: c.name }))}
            onChange={(e, data) => this.setState({ categoryKey: data.value, hasChanged: true })}
            value={categoryKey}
          />
          <Button
            style={{ marginLeft: 10 }}
            color="black"
            content="Save"
            loading={saving}
            disabled={saving || !hasChanged}
            onClick={this.onSave}
          />
        </div>
      </Segment>
    )
  }
}

const getCategoriesFromMenu = menus => {
  const categories = {}

  Object.values(menus).forEach(menu => {
    const categoryKeys = Object.keys(menu.categories || {})

    categoryKeys.forEach(categoryKey => {
      const { name, image } = menu.categories[categoryKey] || {}

      categories[categoryKey] = { name, image }
    })
  })

  return categories
}

const mapState = ({ appCustomization: { promotion }, menus }) => ({
  categories: getCategoriesFromMenu(menus.data),
  promotionCategoryLoaded: promotion.category.loaded,
  loading: menus.loading || promotion.category.loading,
  promoCategory: promotion.category.data,
})

const mapDispatch = {
  getMenus: MenuActions.fetchMenusRequest,
  getCustomization: AppCustomizationActions.getCustomization,
  setSingleCustomization: AppCustomizationActions.setSingleCustomization,
}

export default connect(
  mapState,
  mapDispatch
)(PromotionCategory)


// WEBPACK FOOTER //
// ./src/containers/appCustomization/components/PromotionCategory/index.js